import { render, staticRenderFns } from "./DashBoardCard.vue?vue&type=template&id=5ef0c10a&scoped=true"
import script from "./DashBoardCard.vue?vue&type=script&lang=js"
export * from "./DashBoardCard.vue?vue&type=script&lang=js"
import style0 from "./DashBoardCard.vue?vue&type=style&index=0&id=5ef0c10a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef0c10a",
  null
  
)

export default component.exports